module.exports = __webpack_public_path__ + "static/media/solution-ic-2.df4727c0.svg";